import { Component, ContentChild, EventEmitter, Input, Output, TemplateRef } from '@angular/core';

@Component({
  selector: 'app-ds-info-row',
  templateUrl: './ds-info-row.component.html',
  styleUrls: ['./ds-info-row.component.scss'],
  standalone: false
})
export class DsInfoRowComponent {
  @Input() customStyle: unknown;
  @Input() info: string;
  @Input() title: string;
  @Input() showCustomContent = false;
  @Input() value: string;
  @Output() showInfoHandler = new EventEmitter<any>();

  @ContentChild('customContent') customContent!: TemplateRef<any>;

  showInfo = false;

  clickInfo(): void {
    this.showInfo = !this.showInfo;
    this.showInfoHandler.emit();
  }
}
